(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeCheck', TypeCheck);

    TypeCheck.$inject = ['$resource'];

    function TypeCheck ($resource) {
        var resourceUrl =  'api/type-checks/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-checks/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
